export const GET_PLANS_LIST = "GET_PLANS_LIST"
export const SET_PLANS_LIST = "SET_PLANS_LIST"
export const SET_SHOW_ESTIMATION_SCREEN = "SET_SHOW_ESTIMATION_SCREEN"
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION"
export const SET_CANCEL_SUBSCRIPTION = "SET_CANCEL_SUBSCRIPTION"
export const GET_ESTIMATION_DETAILS = "GET_ESTIMATION_DETAILS"
export const SET_ESTIMATION_DETAILS = "SET_ESTIMATION_DETAILS"
export const UPGRADE_PLAN = "UPGRADE_PLAN"
export const SET_UPGRADE_PLAN = "SET_UPGRADE_PLAN"
export const DOWNGRADE_PLAN = "DOWNGRADE_PLAN"
export const SET_DOWNGRADE_PLAN = "SET_DOWNGRADE_PLAN"
export const CHECK_PLAN_LIMIT = "CHECK_PLAN_LIMIT"
export const SET_PLAN_LIMIT = "SET_PLAN_LIMIT"
export const RESET_RESPONSE_STATUS = "RESET_RESPONSE_STATUS"
export const CLEAR_COUPON_CODE_STATUS = "CLEAR_COUPON_CODE_STATUS"
export const CANCEL_SCHEDULE = "CANCEL_SCHEDULE"
export const SET_CANCEL_SCHEDULE = "SET_CANCEL_SCHEDULE"

